/* ============================================================
   GATING FORMULA — satu-satunya tempat ia dikira
   ============================================================
   Dipakai oleh Rak Formula (/formula) DAN route pembuka
   (/formula/:formulaId), supaya menaip URL formula terkunci
   terus tidak boleh memintas kunci lesen.

   ⛔ Ini salinan TEPAT logik pemilih module lama dalam App.jsx
   (cari `const hasAccess = isAdmin`). Kalau peraturan lesen
   berubah, ia WAJIB dikemas kini di KEDUA-DUA tempat. Kalau
   dilonggarkan di sini sahaja, module berbayar terdedah percuma.
   ============================================================ */

import { getModule } from './modules';

export function computeFormulaAccess({
    mod,
    isAdmin = false,
    userAllowedModules = [],
    userTier,
    flownityTrialUsed = 0,
    maintenanceLockedModules = [],
}) {
    const reg = getModule(mod.id);

    // Module adminOnly langsung tidak dipapar kepada bukan admin.
    const hidden = !!reg.adminOnly && !isAdmin;

    // Admin lulus semua. Selain itu: ID eksplisit dalam allowedModules, ATAU
    // wildcard '*' (yang TIDAK meliputi add-on premium). Module dalam senarai
    // penyelenggaraan dipaksa terkunci untuk semua bukan admin.
    const hasAccess = isAdmin
        || (!maintenanceLockedModules.includes(mod.id)
            && (userAllowedModules.includes(mod.id)
                || (userAllowedModules.includes('*') && !reg.isPremiumAddon)));

    // FLOWNITY: pelanggan berbayar tanpa grant dapat 5 percubaan one-shot.
    const isFlownityTrialCandidate =
        mod.id === 'flownity' && !isAdmin && userTier === 'paid' && !hasAccess;
    const flownityTrialActive = isFlownityTrialCandidate && flownityTrialUsed < 5;

    const isLocked = !!mod.locked || (!hasAccess && !flownityTrialActive);

    let lockReason = 'Formula ini belum dibuka untuk akaun anda.';
    if (mod.locked) {
        lockReason = 'Formula ini sedang diselenggara.';
    } else if (isFlownityTrialCandidate && flownityTrialUsed >= 5) {
        lockReason = 'Percubaan percuma anda telah habis. Dapatkan add-on untuk teruskan.';
    } else if (maintenanceLockedModules.includes(mod.id) && !isAdmin) {
        lockReason = 'Formula ini sedang diselenggara.';
    }

    return { hidden, isLocked, lockReason, isFlownityTrialCandidate, flownityTrialActive };
}
